import { Order, OrderDetail, Review } from '../store';
//tslint:disable:no-reserved-keywords

export namespace ActionNames {
  export enum ReviewActions {
    submit = 'review.submit',
    submitDone = 'review.submitDone',
    preview = 'review.previewImages',
    previewResult = 'review.previewResult',
    fetch = 'review.fetch',
    fetchResult = 'review.fetched',
    rate = 'review.rate',
    comment = 'review.comment',
    error = 'review.error',
    chooseFiles = 'review.chooseFiles',
    list = 'review.list',
    listResult = 'review.listResult',
    author = 'review.author'
  }
  export enum OrderActions {
    list = 'order.list',
    listResult = 'order.listResult',
    fetch = 'order.fetch',
    fetchResult = 'order.fetched'
  }
}

export interface BaseAction {
  type: ActionNames.ReviewActions | ActionNames.OrderActions;
  done?() : void;
}

export interface ReviewSubmit extends BaseAction {
  type: ActionNames.ReviewActions.submit;
  files: File[];
  review: Review;
  token: string;
}

export const submitReview = (files: File[], review: Review, token: string) => ({
  type: ActionNames.ReviewActions.submit,
  files,
  review,
  token
});

export interface SubmitDone extends BaseAction {
  type: ActionNames.ReviewActions.submitDone;
}

export const submitDone = {
  type: ActionNames.ReviewActions.submitDone
};

export interface PreviewImages  extends BaseAction {
  type: ActionNames.ReviewActions.preview;
  files: FileList;
}

export const previewImages = (files: FileList) => ({
  type: ActionNames.ReviewActions.preview,
  files
});

export interface PreviewImageResult extends BaseAction {
  type: ActionNames.ReviewActions.previewResult;
  imageUrls: string[];
}

export const previewImageResults = (imageUrls: string[]) => ({
  type: ActionNames.ReviewActions.previewResult,
  imageUrls
});

export interface FetchReview extends BaseAction {
  type: ActionNames.ReviewActions.fetch;
  token: string;
}

export const fetchReview = (token: string) => ({
  type: ActionNames.ReviewActions.fetch,
  token
});

export interface FetchReviewResult extends BaseAction {
  type: ActionNames.ReviewActions.fetchResult;
  review: Review;
}

export const fetchedReview = (review: Review) => ({
  type: ActionNames.ReviewActions.fetchResult,
  review
});

export interface RateReview extends BaseAction {
  type: ActionNames.ReviewActions.rate;
  rate: number;
}

export const rateReview = (rate: number) => ({
  type: ActionNames.ReviewActions.rate,
  rate
});

export interface CommentReview extends BaseAction {
  type: ActionNames.ReviewActions.comment;
  text: string;
}

export const comment = (text: string) => ({
  type: ActionNames.ReviewActions.comment,
  text
});

export interface AuthorReivew extends BaseAction {
  type: ActionNames.ReviewActions.author;
  text: string;
}

export const author = (text: string) => ({
  type: ActionNames.ReviewActions.author,
  text
});

export interface ErrorAction extends BaseAction {
  type: ActionNames.ReviewActions.error;
  text: string;
}

export const error = (text: string) => ({
  type: ActionNames.ReviewActions.error,
  text
});

export interface ChooseFiles extends BaseAction {
  type: ActionNames.ReviewActions.chooseFiles;
  files: File[];
}

export const chooseFiles = (files: File[]) => ({
  type: ActionNames.ReviewActions.chooseFiles,
  files
});

export interface ListReview extends BaseAction {
  type: ActionNames.ReviewActions.list;
}

export const listReviews = () => ({
  type: ActionNames.ReviewActions.list
});

export interface ListReviewResult extends BaseAction {
  type: ActionNames.ReviewActions.listResult;
  reviews: Review[];
}

export const listReviewResult = (reviews: Review[]) => ({
  type: ActionNames.ReviewActions.listResult,
  reviews
});

export interface ListOrders extends BaseAction {
  type: ActionNames.OrderActions.list;
}

export const listOrders = () => ({
  type: ActionNames.OrderActions.list
});

export interface ListOrderResult extends BaseAction {
  type: ActionNames.OrderActions.listResult;
  orders: Order[];
}

export const listOrderResult = (orders: Order[]) => ({
  type: ActionNames.OrderActions.listResult,
  orders
});

export interface FetchOrder extends BaseAction {
  type: ActionNames.OrderActions.fetch;
  id: number;
}

export const fetchOrder = (id: number) => ({
  type: ActionNames.OrderActions.fetch,
  id
});

export interface FetchedOrder extends BaseAction {
  type: ActionNames.OrderActions.fetchResult;
  order: OrderDetail;
}

export const fetchedOrder = (order: OrderDetail) => ({
  type: ActionNames.OrderActions.fetchResult,
  order
});

export type Action = ReviewSubmit | PreviewImages | PreviewImageResult | FetchReview | FetchReviewResult | RateReview | CommentReview | ErrorAction | ChooseFiles | SubmitDone | ListReview | ListReviewResult |
    ListOrders | ListOrderResult | FetchOrder | FetchedOrder | AuthorReivew;
